<template>
  <div>
    <b-overlay :show="loading" rounded="sm">
      <!-- <v-timeline align-top dense >
        <v-timeline-item :icon="getColumnIcon(c, i)" :color="getColumnColor(c, i)" small v-for="(c,i) in obj.data.columns" :key="i">
        <div class="">{{c.column}}</div>
        <template v-if="obj.data.task.column!=null && c.id==obj.data.task.column.id">
            <v-avatar v-for="(u, i) in obj.data.pinnedUsers" :key="i" :size="32" class="mr-1">
                <v-img :src="u.avator" :style="{'filter': u.seen? 'none':'grayscale(100%)' }"></v-img>
            </v-avatar>
        </template>
        </v-timeline-item>
    </v-timeline> -->

      <ul class="steps steps-vertical">
        <li
          :class="`step-item ${getColumnColor(c, i)}`"
          v-for="(c, i) in obj.data.columns"
          :key="i"
        >
          <a href="" class="step-link">
            <span class="step-number">{{ i + 1 }}</span>
            <span class="step-title">{{ c.column }}</span>
          </a>
        </li>
      </ul>
    </b-overlay>
  </div>
</template>

<script>
import { taskInheritedDetail } from "@/api/task";

export default {
  props: {
    id: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      obj: {
        data: {
          columns: [],
          pinnedUsers: []
        }
      },
      loading: false
    };
  },
  mounted() {
    this.loading = true;
    taskInheritedDetail({
      params: { id: this.id },
      store: this.$store
    }).then(res => {
      this.loading = false;
      this.obj = res;
      //console.log(res);
    });
  },
  methods: {
    getColumnColor(c, i) {
      if (
        this.obj.data.task.column != null &&
        c.id == this.obj.data.task.column.id
      ) {
        return "orange";
      } else if (
        this.obj.data.task.column != null &&
        this.obj.data.columns
          .map(function(c) {
            return c.id;
          })
          .indexOf(this.obj.data.task.column.id) > i
      ) {
        return "green";
      } else if (this.obj.data.task.column == null) {
        return "green";
      } else {
        return "grey";
      }
    },
    getColumnIcon(c, i) {
      if (
        this.obj.data.task.column != null &&
        c.id == this.obj.data.task.column.id
      ) {
        return "mdi-chevron-right";
      } else if (
        this.obj.data.task.column != null &&
        this.obj.data.columns
          .map(function(c) {
            return c.id;
          })
          .indexOf(this.obj.data.task.column.id) > i
      ) {
        return "mdi-account-check";
      } else if (this.obj.data.task.column == null) {
        return "mdi-account-check";
      } else {
        return "";
      }
    }
  }
};
</script>

<style></style>
